module.exports = __webpack_public_path__ + "static/media/08 - Clap.7bdee98b.wav";